import styled from 'styled-components';
import { StyledTotalsSummaryProps } from './TotalsSummary.types';

export const StyledTotalsSummary = styled.div<StyledTotalsSummaryProps>`
  .total-summary-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ${(props) => props.customStyle}
`;
